import React from "react";
import { GraduationCap, Star } from "lucide-react";

export default function Logo({ size = 44 }) {
  return (
    <div
      className="logo-badge relative rounded-full flex items-center justify-center"
      style={{ width: size, height: size }}
      aria-label="CYA Youth Academy Logo"
    >
      <GraduationCap className="text-[#0a1740]" size={size * 0.55} strokeWidth={2.4} />
      <Star
        className="absolute text-amber-400 fill-amber-400"
        size={size * 0.28}
        style={{ top: size * 0.06, right: size * 0.14 }}
      />
    </div>
  );
}
